var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pub-home" },
    [
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          {
            staticClass: "main-header",
            attrs: { slot: "header" },
            slot: "header"
          },
          [
            _c("h3", [_vm._v("通知公告")]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "right-top-close",
                attrs: { type: "primary" },
                nativeOn: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  }
                }
              },
              [_c("i", { staticClass: "el-icon-close" })]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-body" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading"
                  }
                ],
                staticStyle: {
                  margin: "0 30px",
                  width: "auto",
                  cursor: "pointer"
                },
                attrs: { data: _vm.list },
                on: { "row-click": _vm.rowClick }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", label: "序号" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "title", label: "标题" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "sendTime", label: "发布时间" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            _vm._s(_vm._f("formatDateTime")(scope.row.sendTime))
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.showpub
        ? [
            _c("PubInfo", {
              attrs: { notice: _vm.noticeRow },
              on: { cancel: _vm.closewindow }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-653f69e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-653f69e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/components/Pub.vue
// module id = null
// module chunks = 